import { EventGraphBase, EventGraphNode, EventGraphNodeNotice, EventGraphNodeRender, EventHandlerCmdEnd, EventHandlerGrid, EventHandlerObjectInput, EventHandlerStart, NeedInputEnum, PythaEventName, UpdateType } from "pytha2";
import { EventHandlerUpdateAxisNetElevation } from "../event-handler/EHUpdateAxisNetElevation";


/**
 * 修改轴网图元标高
 */
export class EventGraphUpdateAxisNetElevation extends EventGraphBase {

    /**
     * UpdateAxisNetElevation指令 用于注册事件图
     */
    static cmd = 'UPDATEAXISNETELEVATION';

    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                type: NeedInputEnum.ACTIVE,
                description: "",
                option: 'AxisNets',
                inputTypes: [PythaEventName.OBJECT]
            }]
        });
        const node3 = new EventGraphNode(this, EventHandlerObjectInput);
        const node4 = new EventGraphNode(this, EventHandlerUpdateAxisNetElevation);
        const node5 = new EventGraphNode(this, EventHandlerGrid);
        const node6 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node7 = new EventGraphNodeRender(this, true, UpdateType.ALL);

        this.addEdge(node1, node2);
        this.addEdge(node2, node3);
        this.addEdge(node3, node4);
        this.addEdge(node4, node5);
        this.addEdge(node5, node7);
        this.addEdge(node7, node6);

        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;

        // https://event.graph.tncet.com/graphs/130
    }
}
